import { render, staticRenderFns } from "./languageSettings.vue?vue&type=template&id=09f86982&scoped=true"
import script from "./languageSettings.vue?vue&type=script&lang=js"
export * from "./languageSettings.vue?vue&type=script&lang=js"
import style0 from "./languageSettings.vue?vue&type=style&index=0&id=09f86982&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f86982",
  null
  
)

export default component.exports